import animAcmeSrc from "@/assets/images/anim-acme.png"
import animHotCupsSrc from "@/assets/images/anim-hot-cups.png"
import animLumiereBelleSrc from "@/assets/images/anim-lumiere-belle.png"
import animSeemerRaysSrc from "@/assets/images/anim-seemer-rays.png"
import avatarEllieSrc from "@/assets/images/avatar-ellie.png"
import avatarJohnnySrc from "@/assets/images/avatar-johnny.png"
import avatarRachelSrc from "@/assets/images/avatar-rachel.png"

// Handle images for header avatar
const chatImages: any = {
  acme: animAcmeSrc,
  "hot-cups": animHotCupsSrc,
  "lumiere-belle": animLumiereBelleSrc,
  "seemer-rays": animSeemerRaysSrc,
}
export const getChatImage = (image: string) => chatImages[image]

// Handle avatar images
const avatarImages: any = {
  ellie: avatarEllieSrc,
  johnny: avatarJohnnySrc,
  rachel: avatarRachelSrc,
}
export const handleAvatarImage = (avatar: string) => avatarImages[avatar]

// Simulate a timing delay for the last message based on the per-word counting algorithm
export const getWordLength = (input: string): number => {
  if (input) {
    return input.split(" ").length
  } else {
    // For chat items that don't have a message
    return 1
  }
}
